import { paymentSource } from '@99designs/brief';
import { Order, StructuredBrief } from '@99designs/graph-utils/types';
import { ProductFixedPriceProjectFragment } from './Brief.generated';

type Brief = Pick<StructuredBrief, 'partnerCoupon'> & {
    order?: Pick<Order, 'id'> | null;
    product?: ProductFixedPriceProjectFragment | null;
};

export function getPaymentSource(brief: Brief): paymentSource {
    if (
        brief.product &&
        brief.partnerCoupon?.state === 'VALID' &&
        brief.partnerCoupon?.validPackages.includes(brief.product.key)
    ) {
        return 'fully-funded';
    }

    // if no coupon is present or if the coupon is not VALID,
    // we can still have a paid-for order (e.g. logo-web-bundle)
    if (brief.order) {
        return 'paid';
    }

    return undefined;
}
